const MINUTE = 60;
const HOUR = 60 * MINUTE;
const DAY = 24 * HOUR;

export const formatRelative = (iso: string, now: Date = new Date()): string => {
  const fetched = new Date(iso);
  if (Number.isNaN(fetched.getTime())) return "—";
  const seconds = Math.max(
    0,
    Math.floor((now.getTime() - fetched.getTime()) / 1000),
  );
  if (seconds < 5) return "just now";
  if (seconds < MINUTE) return `${seconds}s ago`;
  if (seconds < HOUR) return `${Math.floor(seconds / MINUTE)}m ago`;
  if (seconds < DAY) return `${Math.floor(seconds / HOUR)}h ago`;
  return `${Math.floor(seconds / DAY)}d ago`;
};
